export default class CartController {
    constructor() {
        this.cart = [];
        this.totalCost = 0;
        this.totalWeight = 0;
        this.shippingCosts = null; // Initialize the shippingCosts
        this.shippingLoaded = false;      // ✅ NEW
        this.shippingLoadError = false;   // ✅ NEW
        this.shippingPromise = this.fetchShippingCosts(); // ✅ keep the promise
        this.finalCostValue = 0;
        this.paymentMethodSelected = false; // Flag to track if a payment method is selected
        this.selectedSamples = [];
        this.samplesAllowed = 0;
        this.perfumeOptionsCache = null; // για να μη ξανακάνει fetch συνέχεια
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
        });
    }

    setupEventListeners() {
        const chcktBtn = document.getElementById('chcktBtn');
        if (chcktBtn) {
            const paymentMethodMessage = document.getElementById('paymentMethodMessage');
            const bankTransferBtn = document.getElementById('bankTransferBtn');
            const cardPaymentBtn = document.getElementById('cardPaymentBtn');
            const cardPaymentForm = document.getElementById('purchaseForm');

            chcktBtn.disabled = true;
            this.shippingPromise.finally(() => {
                if (!this.shippingLoadError) {
                    chcktBtn.disabled = false;
                }
            });
    
            chcktBtn.addEventListener('click', () => {
                if (this.cart.length === 0) {
                    // If cart is empty, return without doing anything
                    alert("Your cart is empty. Please add items before proceeding to checkout.");
                    return;
                }


                if (!this.shippingLoaded || !this.shippingCosts) {
                    alert("Shipping information is still loading or unavailable. Please try again in a moment.");
                    return;
                }

                // const totalWeightWithPackaging = this.totalWeight * 1.1;
                // if (totalWeightWithPackaging > 2) {
                //     alert("Your order exceeds the 2kg limit including packaging. Please adjust your cart before checking out.");
                //     return;
                // }
                
                // Display the payment method message and buttons
                paymentMethodMessage.style.display = 'block';
            });
    
            // Add event listener to the payment method buttons
            bankTransferBtn.addEventListener('click', () => {
                this.updateHiddenWeightInput();
                this.showCheckoutModal(); // Use arrow function to preserve 'this' context
                // Set form action to process_bank_transfer.php
                document.getElementById('paymentMethod').value = 'Bank'; // Set the value attribute
                document.getElementById('paymentForm').action = './process_bank_transfer.php';
                this.paymentMethodSelected = true; // Set the flag to true
            });
            
            cardPaymentBtn.addEventListener('click', () => {
                this.updateHiddenWeightInput();
                this.showCheckoutModal(); // Use arrow function to preserve 'this' context
                // Set form action to route.php?act=send
                document.getElementById('paymentMethod').value = 'Card'; // Set the value attribute
                document.getElementById('paymentForm').action = './route.php?act=send';
                this.paymentMethodSelected = true; // Set the flag to true
            });
            
            document.getElementById('paymentForm').addEventListener('submit', (event) => {
                event.preventDefault();

                const form = document.getElementById('paymentForm');

                const submitButton = document.getElementById('paymentSubmitButton');

                if (!this.paymentMethodSelected) {
                    alert('Please select a payment method before moving on.');
                    return;
                }
            
                const countrySelect = document.getElementById('country');
                const country = countrySelect ? countrySelect.value : 'GR';
                const shippingCost = this.calculateShippingCost(country);
            
                if (!Number.isFinite(shippingCost)) {
                    alert('There was a problem calculating shipping. Please try again or contact us.');
                    return;
                }
            
                // Εμφανίζει τα browser validation messages
                if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                }

                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.value = 'Processing...';
                }
            
                // Submit χωρίς να ξαναμπεί σε loop
                HTMLFormElement.prototype.submit.call(form);
            });
            
            
        }

        const closeButton = document.querySelector('.close-button-cart');
        if (closeButton) {
            closeButton.addEventListener('click', () => this.hideCheckoutModal());
        }

        window.addEventListener('click', (event) => {
            if (event.target === document.getElementById('checkoutModal')) {
                this.hideCheckoutModal();
            }
        });

        const countrySelect = document.getElementById('country');
        if (countrySelect) {
            countrySelect.addEventListener('change', () => {
                this.updateCheckoutModal();
            });
        }

        this.initSamplesSection();
    }
    convertKgToMl(kg) {
        return kg * 1000;
    }
    showAddToCartPopup(product) {
        const popup = document.createElement('div');
        popup.classList.add('cart-popup');
    
        // Check if product.product or product.productname is defined
        const productName = product.product || product.productname;
        if (!productName) {
            console.error('Product name not found in product object:', product);
            return;
        }
    
        popup.innerHTML = `<p>${productName} added to cart</p>`;
        document.body.appendChild(popup);
    
        setTimeout(() => {
            popup.remove();
        }, 3000);
    }
    

    addToCart(product, productPrice, productWeight, productScent, productFragrance, productDuration, brand, selectedWeightCategory) {
        // console.log(`1.Adding to cart: ${product}, Weight: ${productWeight}kg, name: ${product}kg, Price: €${productPrice}, Weight: ${productWeight}, Scent: ${productScent}, Fragrance: ${productFragrance}, Fragrance: ${productDuration}`);
        console.log('Raw productWeight:', productWeight); // Log for debugging


        const productName = product.productname;
        const packagingMultiplier = 1.1;
        const item = {
            ...product,
            productname: productName,
            weight: Number((parseFloat(productWeight) * packagingMultiplier).toFixed(3)), 
            baseWeight: parseFloat(productWeight), // Store original weight for reference (optional)
            price: parseFloat(productPrice), 
            id: `${product.productid}`, 
            scent: productScent,
            fragrance:  productFragrance,
            duration:  productDuration,
            brand:  `${product.brand}` 
        };
        // console.log(item)
        if (selectedWeightCategory){
            item.selectedWeightCategory = selectedWeightCategory;

        }
        // console.log('Item (with packaging weight):', item);



        const baseWeight = this.cart.reduce((total, item) => total + (item.weight * item.quantity), 0);
        const projectedTotalWeight = baseWeight + item.weight;

        console.log('Current Total Weight (with packaging):', baseWeight);
        console.log('Projected Total Weight (with packaging):', projectedTotalWeight);
            
        // Block if projected weight BEFORE packaging exceeds 1.85kg
        if (projectedTotalWeight > 1.85) {
            alert('Adding this item would exceed the 2kg shipping limit (including packaging). Please adjust your cart.');
            return;
        }
        
        // console.log(`2.Adding to cart: ${product}, Weight: ${productWeight}kg, Price: €${productPrice}, Scent: ${productWeight}, Fragrance: ${productFragrance}`);

        this.processCartItem(item);
    }

    processCartItem(item) {
        if (item.brand){
            // console.log(item.productname)
            item.brand = item.brand
        }
        if (item.productname) {
            item.product = item.productname;
        }

        // Φτιάχνουμε "πλούσιο" ID που ξεχωρίζει τα διαφορετικά combos
        const scentKey      = item.scent      || 'no-scent';
        const fragranceKey  = item.fragrance  || 'no-fragrance';
        const durationKey   = item.duration   || 'no-duration';
        const weightKey     = item.selectedWeightCategory || item.weight.toFixed(3);

        const itemID = `${item.productid}-${weightKey}-${scentKey}-${fragranceKey}-${durationKey}`;
        item.id = itemID;

        console.log('Cart item ID:', itemID); // optional, για να το βλέπεις στη κονσόλα

        const existingItem = this.cart.find(cartItem => cartItem.id === item.id);

        if (existingItem) {
            // Ακριβώς ίδιο προϊόν, ίδιο scent, ίδιο weight κτλ → απλά αυξάνουμε quantity
            existingItem.quantity += 1;
        } else {
            // Νέος συνδυασμός → νέα γραμμή στο καλάθι
            this.cart.push({ ...item, quantity: 1 });
        }

        this.updateCartDisplay();
        this.showAddToCartPopup(item);
    }
    updateCartBadge() {
        const badge = document.getElementById('cartBadge');
        if (!badge) return;

        // total = sum of all item quantities
        // each unique product+size+scent combo is a separate entry
        const total = this.cart.reduce((sum, item) => sum + item.quantity, 0);

        if (total === 0) {
            badge.style.display = 'none';
        } else {
            badge.style.display = 'inline-flex';
            badge.textContent = total > 99 ? '99+' : total;
            // bump animation on every change
            badge.classList.remove('bump');
            void badge.offsetWidth; // force reflow to restart animation
            badge.classList.add('bump');
        }
    }

    updateCartDisplay() {
        const cartItemsElement = document.getElementById('cartItems');
        cartItemsElement.innerHTML = ''; // Clear existing cart items
        let totalCost = 0;
        let totalWeight = 0; // Initialize total weight
        
        this.cart.forEach((item, index) => {
            // Accumulate total weight for shipping calculation
            totalWeight += item.weight * item.quantity;
            totalCost += item.price * item.quantity;
            let productName;
            if (item.weight === 0.007 || item.weight === 0.014) {
                // Modify the productName
                productName = `${item.product} (Pure)`;
            } else {
            
                // Check if it's a candle
                if (item.duration) {
                    productName = `${item.product} (${item.duration}h)`;
                } else {
                    // Handle the case where selectedWeight is not recognized
                    productName = `${item.product} ${item.weight}`;
                }
            }
            
            if (item.scent) {
                productName += ` with ${item.scent}`;
            }
            
            if (item.fragrance) {
                productName += ` with ${item.fragrance}`;
            }
            const itemElement = document.createElement('div');
            itemElement.classList.add('cart-item');
            let displayWeight = item.selectedWeightCategory ? item.selectedWeightCategory : `${item.weight.toFixed(3)}kg`;
            itemElement.innerHTML = `
                <span class="cart-item-name">${productName}</span> x 
                <span class="cart-item-quantity">${item.quantity}</span>
                <span class="cart-item-price">\u20AC${(item.price * item.quantity).toFixed(2)}</span>
                <span class="cart-item-weight">${displayWeight}</span>
                <button class="remove-item" data-index="${index}">Remove</button>
            `;
            cartItemsElement.appendChild(itemElement);

            itemElement.querySelector('.remove-item').addEventListener('click', () => this.removeFromCart(index));
        });

        const weightInfoElement = document.getElementById('weightInfo');
        weightInfoElement.textContent = `Total Weight: ${totalWeight.toFixed(2)} kg.`;
        
        const weightIcon = document.getElementById('weightIcon');
        if (totalWeight > 0) {
            weightIcon.style.display = 'inline'; // Make the icon visible if there's any weight
            // Optionally, change the icon or its style based on the weight
            // For example, changing the icon color if close to the limit:
            if (totalWeight > 1.8) { // Example threshold, adjust as needed
                weightIcon.style.color = 'red'; // Change color to red if close to the limit
            } else {
                weightIcon.style.color = 'black'; // Default color
            }
        } else {
            weightIcon.style.display = 'none'; // Hide the icon if the cart is empty
        }
        document.getElementById('cartTotal').textContent = `Cost: \u20AC${totalCost.toFixed(2)}`;
        this.totalCost = totalCost;
        this.totalWeight = totalWeight;
        this.updateCheckoutModal();
        this.syncSamplesWithCartTotal();
        this.updateCartBadge();
    }

    updateCheckoutModal() {
        const countrySelect = document.getElementById('country');
        const country = countrySelect ? countrySelect.value : "GR";
        const shippingCost = this.calculateShippingCost(country);


        // ✅ NEW: if shipping can't be calculated, don't push bogus values
        if (!Number.isFinite(shippingCost)) {
            document.getElementById('modalCartTotal').textContent  = `Base Total: €${this.totalCost.toFixed(2)}`;
            document.getElementById('modalCartWeight').textContent = `Total Weight: ${this.totalWeight.toFixed(3)} kg`;
            document.getElementById('shippingCost').textContent    = `Shipping Cost: —`;
            document.getElementById('finalCost').textContent       = `Total with Shipping: —`;
            document.getElementById('orderAmount').value           = '';
            return;
        }

        document.getElementById('modalCartTotal').textContent = `Base Total: €${this.totalCost.toFixed(2)}`;
        document.getElementById('modalCartWeight').textContent = `Total Weight: ${this.totalWeight.toFixed(3)} kg`;
        document.getElementById('shippingCost').textContent = `Shipping Cost: €${shippingCost.toFixed(2)}`;

        this.finalCostValue = this.totalCost + shippingCost;
        console.log(this.finalCostValue);

        document.getElementById('finalCost').textContent = `Total with Shipping: €${this.finalCostValue.toFixed(2)}`;
        document.getElementById('orderAmount').value = this.finalCostValue.toFixed(2); // Set the value attribute


    }

    async showCheckoutModal() {
        if (this.cart.length === 0) {
            alert("Your cart is empty. Please add items before proceeding to checkout.");
            return;
        }

    // ✅ NEW: make sure shipping is ready
        if (!this.shippingLoaded || this.shippingLoadError) {
            alert("Shipping information is not available right now. Please try again later.");
            return;
        }


        const orderedItems = this.cart.map(item => {
            return {
                productName: item.product,
                fragrance: item.fragrance,
                duration: item.duration,
                scent: item.scent,
                quantity: item.quantity,
                price: item.price,
                weight: item.weight,
                weightLabel: item.selectedWeightCategory || item.weight, // readable label e.g. "30ml"
                brand: item.brand
            };
        });
    
        // Store or process the orderedItems as needed
        console.log("Ordered Items:", orderedItems);
        this.updateCheckoutModal();


        // samples: 1 sample per 17€ base total (χωρίς μεταφορικά)
        this.syncSamplesWithCartTotal();
        // ✅ NEW: don't open modal if totals are broken
        if (!Number.isFinite(this.finalCostValue)) {
            alert("There was a problem calculating your total. Please refresh the page and try again.");
            return;
        }


        document.getElementById('checkoutModal').style.display = 'block';
    
        const orderId = Math.floor(Math.random() * 1000000000000);
    
        document.getElementById('orderIdInput').value = orderId;

        const buildLabeledPart = (label, value) => {
            if (!value) return '';
            if (value === 'undefined' || value === 'null') return '';
            return ` - ${label}:${value}`;
        };


        const orderDesc = orderedItems.map(item => {
            const brandDesc     = buildLabeledPart('BRAND', item.brand);
            const scentDesc     = buildLabeledPart('SCENT', item.scent);
            const fragranceDesc = buildLabeledPart('FRAGRANCE', item.fragrance);
            const durationDesc  = buildLabeledPart('DURATION', item.duration);
            const sizeLabel     = item.weightLabel || item.weight;
 
            return `${item.productName} - qty:${item.quantity} - ${sizeLabel}${brandDesc}${scentDesc}${fragranceDesc}${durationDesc}`;
        }).join('\n');
        // Set the value of the orderDescInput input element
        document.getElementById('orderDescInput').value = orderDesc;
        document.getElementById('orderSamplesInput').value = this.selectedSamples.join(' / ');  
    }
    

    hideCheckoutModal() {
        document.getElementById('checkoutModal').style.display = 'none';
    }
        async fetchShippingCosts() {
        try {
            const response = await fetch('./get_shipping_cost.php');
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
        
            const data = await response.json();
        
            if (!Array.isArray(data) || data.length === 0) {
                throw new Error('Empty shipping data');
            }
        
            this.shippingCosts = data;
            this.shippingLoaded = true;
            this.shippingLoadError = false;
            console.log('Shipping costs loaded:', this.shippingCosts);
        } catch (err) {
            console.error('Failed to load shipping costs:', err);
            this.shippingCosts = null;
            this.shippingLoaded = false;
            this.shippingLoadError = true;
        }
    }
        async loadPerfumeOptions() {
            if (this.perfumeOptionsCache) return this.perfumeOptionsCache;
                
            const res = await fetch('./get_perfumes.php');
            const data = await res.json();
                
            const options = data
                .filter(p => p.product)
                .map(p => ({
                    product: p.product,
                    gender: p.gender || ''
                }))
                .sort((a, b) => a.product.localeCompare(b.product, 'el', { sensitivity: 'base' }));
            
            this.perfumeOptionsCache = options;
            return options;
        }

        

            renderSamplesUI() {
                const section = document.getElementById('samplesSection');
                const allowedEl = document.getElementById('samplesAllowed');
                const remainingEl = document.getElementById('samplesRemaining');
                const listEl = document.getElementById('selectedSamplesList');
                const hiddenInput = document.getElementById('orderSamplesInput');
                        
                if (!section || !allowedEl || !remainingEl || !listEl) return;
                        
                if (this.samplesAllowed > 0) {
                    section.style.display = 'block';
                } else {
                    section.style.display = 'none';
                    this.selectedSamples = [];
                }
            
                allowedEl.textContent = String(this.samplesAllowed);
                remainingEl.textContent = String(this.samplesAllowed - this.selectedSamples.length);
            
                listEl.innerHTML = '';
                this.selectedSamples.forEach((s, idx) => {
                    const row = document.createElement('div');
                    row.className = 'sample-row';
                    row.innerHTML = `
                        <span>${s}</span>
                        <button type="button" class="remove-sample" data-idx="${idx}">✖</button>
                    `;
                    listEl.appendChild(row);
                });
            
                listEl.querySelectorAll('.remove-sample').forEach(btn => {
                    btn.addEventListener('click', () => {
                        const i = Number(btn.getAttribute('data-idx'));
                        this.selectedSamples.splice(i, 1);
                        this.renderSamplesUI();
                    });
                });
            
                if (hiddenInput) {
                    hiddenInput.value = this.selectedSamples.join(' / ');
                }
            }

            renderFilteredSampleOptions() {
                const selectEl = document.getElementById('samplesSelect');
                const searchEl = document.getElementById('samplesSearch');
                const genderEl = document.getElementById('samplesGenderFilter');
            
                if (!selectEl || !searchEl || !genderEl || !this.perfumeOptionsCache) return;
            
                const searchValue = searchEl.value.trim().toLowerCase();
                const genderValue = genderEl.value;
            
                let filtered = this.perfumeOptionsCache.filter(item => {
                    const matchesSearch = item.product.toLowerCase().includes(searchValue);
                
                    if (genderValue === 'all') return matchesSearch;
                
                    if (genderValue === 'unisex') {
                        return matchesSearch && item.product.toLowerCase().includes('unisex');
                    }
                
                    return matchesSearch && item.gender === genderValue;
                });
            
                if (filtered.length === 0) {
                    selectEl.innerHTML = `<option value="">No perfumes found</option>`;
                    return;
                }
            
                selectEl.innerHTML = filtered
                    .map(item => `<option value="${item.product}">${item.product}</option>`)
                    .join('');
            }



            syncSamplesWithCartTotal() {
                this.samplesAllowed = Math.floor(this.totalCost / 17);

                if (this.selectedSamples.length > this.samplesAllowed) {
                    this.selectedSamples = this.selectedSamples.slice(0, this.samplesAllowed);
                }
            
                this.renderSamplesUI();
            }
            
            async initSamplesSection() {
                const selectEl = document.getElementById('samplesSelect');
                const addBtn = document.getElementById('addSampleBtn');
                const searchEl = document.getElementById('samplesSearch');
                const genderEl = document.getElementById('samplesGenderFilter');

                if (!selectEl || !addBtn || !searchEl || !genderEl) return;

                await this.loadPerfumeOptions();
                this.renderFilteredSampleOptions();

                searchEl.oninput = () => {
                    this.renderFilteredSampleOptions();
                };
            
                genderEl.onchange = () => {
                    this.renderFilteredSampleOptions();
                };
            
                addBtn.onclick = () => {
                    if (this.selectedSamples.length >= this.samplesAllowed) {
                        alert('You have already selected all available samples.');
                        return;
                    }
                
                    const choice = selectEl.value;
                    if (!choice || choice === 'No perfumes found') return;
                
                    if (this.selectedSamples.includes(choice)) {
                        alert('You have already selected this sample.');
                        return;
                    }
                
                    this.selectedSamples.push(choice);
                    this.renderSamplesUI();
                };
            
                this.renderSamplesUI();
            }
    
    
        calculateShippingCost(country) {
        // ✅ NEW: don't pretend shipping is 0 if data missing
        if (!this.shippingLoaded || !this.shippingCosts) {
            console.error("Shipping costs data not loaded.");
            return NaN;
        }
    
        const baseTotalWeight = this.cart.reduce(
            (total, item) => total + (item.baseWeight * item.quantity),
            0
        );
    
        if (country === "GR") {
            const grShipping = this.shippingCosts.find(cost => cost.country === "GR");
            if (!grShipping) {
                console.error('No GR shipping rule found.');
                return NaN;
            }
        
            const grPrice = Number(grShipping.price);
            if (!Number.isFinite(grPrice)) {
                console.error('Invalid GR shipping price:', grShipping.price);
                return NaN;
            }
        
            // ✅ same rule as before: free shipping ONLY for GR over €70
            return this.totalCost > 70 ? 0 : grPrice;
        } else {
            let weightCategory;
            if (baseTotalWeight < 0.440) {
                weightCategory = "ElseLow";
            } else if (baseTotalWeight < 0.900) {
                weightCategory = "ElseMid";
            } else if (baseTotalWeight <= 1.850) {
                weightCategory = "ElseBig";
            } else {
                console.error('Base weight exceeds max category:', baseTotalWeight);
                return NaN;
            }
        
            const otherShipping = this.shippingCosts.find(
                cost => cost.weightcategory === weightCategory
            );
        
            if (!otherShipping) {
                console.error('No shipping rule found for weight category:', weightCategory);
                return NaN;
            }
        
            const otherPrice = Number(otherShipping.price);
            if (!Number.isFinite(otherPrice)) {
                console.error('Invalid shipping price for', weightCategory, otherShipping.price);
                return NaN;
            }
        
            return otherPrice;
        }
    }
    
    updateHiddenWeightInput() {
        const totalWeight = this.totalWeight.toFixed(2);
        document.getElementById('hiddenWeightInput').value = totalWeight;
    }
    

    removeFromCart(index) {
        this.cart.splice(index, 1);
        this.updateCartDisplay();
    }
}
